import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import React, { lazy, Suspense, useEffect, useState } from "react";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import { AuthProvider } from "./Components/Routes/AuthContext";
import PrivateRoute, { PublicRoute } from "./Components/Routes/PrivateRoute";
import StaticData from "./Static/StaticData.json";
import Loader from "./Components/Utils/Loader";
import ScrollToTop from "./Components/ScrollToTop";

const Home = lazy(() => import("./Components/Home"));
const About = lazy(() => import("./Components/About"));
const Contact = lazy(() => import("./Components/Contact"));
const Feature = lazy(() => import("./Components/Feature"));
const Login = lazy(() => import("./Components/Login"));
const SignUp = lazy(() => import("./Components/SignUp"));
const Dashboard = lazy(() => import("./Components/Dashboard"));
const PrivacyPolicy = lazy(() => import("./Components/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./Components/TermsOfService"));

const App = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Navbar StaticData={StaticData} windowWidth={windowWidth} />
        <div style={{ height: "86px" }} />

        <ScrollToTop behavior="auto" />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/features"
              element={<Feature />}
            />
            <Route path="/login" element={<PublicRoute element={<Login />} />} />
            <Route path="/signup" element={<PublicRoute element={<SignUp />} />} />
            <Route path="/features" element={
              <PrivateRoute element={<Feature />} />
            } />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route
              path="/dashboard/*"
              element={
                <PrivateRoute
                  element={<Dashboard windowWidth={windowWidth} />}
                />
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </Router>
    </AuthProvider>
  );
};

export default App;
